export default __webpack_public_path__ + "static/media/left.499127b3.svg";